export default __webpack_public_path__ + "static/media/soulofmitra.48a737c6.png";